import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'landing',
        path: '/',
        component: React.lazy(() => import('views/auth-views/landing')),
    },
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'courses',
        path: `${APP_PREFIX_PATH}/courses`,
        component: React.lazy(() => import('views/app-views/courses')),
    },
    {
        key: 'course',
        path: `${APP_PREFIX_PATH}/course`,
        component: React.lazy(() => import('views/app-views/course')),
    },
    {
        key: 'course.detail',
        path: `${APP_PREFIX_PATH}/course/:courseId`,
        component: React.lazy(() => import('views/app-views/course')),
    },
    {
        key: 'management',
        path: `${APP_PREFIX_PATH}/management`,
        component: React.lazy(() => import('views/app-views/management')),
    },
    {
        key: 'modulos',
        path: `${APP_PREFIX_PATH}/modulos`,
        component: React.lazy(() => import('views/app-views/modulos/ModulosList')),
    },
    {
        key: 'modulos.novo',
        path: `${APP_PREFIX_PATH}/modulos/novo`,
        component: React.lazy(() => import('views/app-views/modulos/ModuloFormPage')),
    },
    {
        key: 'modulos.editar',
        path: `${APP_PREFIX_PATH}/modulos/editar/:id`,
        component: React.lazy(() => import('views/app-views/modulos/ModuloFormPage')),
    },
    {
        key: 'modulos.visualizar',
        path: `${APP_PREFIX_PATH}/modulos/visualizar/:id`,
        component: React.lazy(() => import('views/app-views/modulos/ModuloViewPage')),
    },
    {
        key: 'produtos',
        path: `${APP_PREFIX_PATH}/produtos`,
        component: React.lazy(() => import('views/app-views/produtos/ProdutosList')),
    },
    {
        key: 'produtos.novo',
        path: `${APP_PREFIX_PATH}/produtos/novo`,
        component: React.lazy(() => import('views/app-views/produtos/ProdutoFormPage')),
    },
    {
        key: 'produtos.editar',
        path: `${APP_PREFIX_PATH}/produtos/editar/:id`,
        component: React.lazy(() => import('views/app-views/produtos/ProdutoFormPage')),
    },
    {
        key: 'produtos.visualizar',
        path: `${APP_PREFIX_PATH}/produtos/visualizar/:id`,
        component: React.lazy(() => import('views/app-views/produtos/ProdutoViewPage')),
    }
]